import { StepCheck } from 'assets/images/web-isn';
import { parseISO, setHours } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router';
import { getQueryString } from 'utils/params';
import { getApartmentDetail } from '../payment.api';
import StepOneComponent from './stepOne.component';
import StepTwoComponent from './stepTwo.component';

// Step
const Step = props => {
  const newPageIndex = parseInt(props.pageIndex);

  // if (newPageIndex > 3) return;
  return (
    <div
      className={`${newPageIndex === 1 ? 'Stepper__step' : newPageIndex === 2 ? 'Stepper__step-2' : 'Stepper__step-3'}`}
    >
      <div className="Stepper__indicator">
        <span
          className={`${
            newPageIndex === props.indicator
              ? 'Stepper__info'
              : newPageIndex > props.indicator
              ? 'Stepper__info Stepper__info--img'
              : 'Stepper__info--not-active'
          }`}
        >
          {newPageIndex > props.indicator ? <img src={StepCheck} alt="step-checker" /> : props.indicator}
        </span>
      </div>
      <div
        className={`${
          newPageIndex === props.indicator || newPageIndex > props.indicator
            ? 'Stepper__label'
            : 'Stepper__label--not-active'
        }`}
      >
        {props.title}
      </div>
    </div>
  );
};

// Overlay
const Stepper = props => <div className="Stepper">{props.children}</div>;

function PaymentSummaryComponent() {
  const { t } = useTranslation();
  const { apartmentId } = useParams();
  const history = useHistory();
  const { language } = useParams();
  const [apartmentDetail, setApartmentDetail] = useState(null);
  const authUserData = JSON.parse(localStorage.getItem('authUserData'));
  const searchDataCheckInOut = JSON.parse(sessionStorage.getItem('searchDataCheckInOut'));
  const resSearchDataCheckInOut = searchDataCheckInOut;
  sessionStorage.removeItem('searchDataCheckInOut');

  const [initialValues, setInitialValues] = useState({
    language: language,
    bookingTransfer: '',
    fullName:
      authUserData?.userInfo?.fullName !== null && authUserData?.userInfo?.fullName !== undefined
        ? authUserData.userInfo.fullName
        : '',
    email:
      authUserData?.userInfo?.email && authUserData?.userInfo?.email !== null
        ? authUserData?.userInfo?.email
        : authUserData?.userInfo?.userEmail && authUserData?.userInfo?.userEmail !== null
        ? authUserData?.userInfo?.userEmail
        : '',
    phoneNumber:
      authUserData?.userInfo?.phoneNumber && authUserData?.userInfo?.phoneNumber !== null
        ? authUserData?.userInfo?.phoneNumber
        : authUserData?.userInfo?.userPhone && authUserData?.userInfo?.userPhone !== null
        ? authUserData?.userInfo?.userPhone
        : '',
    checkInOut: [
      resSearchDataCheckInOut !== null ? setHours(parseISO(resSearchDataCheckInOut.checkIn), 12) : null,
      resSearchDataCheckInOut !== null ? setHours(parseISO(resSearchDataCheckInOut.checkOut), 12) : null,
    ],
    isVatInvoice: false,
    companyName: '',
    companyAddress: '',
    taxCode: '',
    isReservation: false,
    reservationFullName: '',
    reservationEmail: '',
    otherRequirements: '',
  });

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    getApartmentDetail(getQueryString({ language, apartmentId })).then(res => {
      if (res) {
        setApartmentDetail(res);
      }
    });
    if (authUserData === null) {
      history.push(`/${language}/`);
    }

    return () => {
      setInitialValues(null);
      setApartmentDetail(null);
      setCurrentStep(0);
    };
    //eslint-disable-next-line
  }, []);

  const handleNextStep = newData => {
    setInitialValues(prev => ({ ...prev, ...newData }));
    setCurrentStep(prev => prev + 1);
  };

  const handlePrevStep = newData => {
    setInitialValues(prev => ({ ...prev, ...newData }));
    setCurrentStep(prev => prev - 1);
  };

  const steps = [
    <StepOneComponent key="1" initialValues={initialValues} next={handleNextStep} apartmentDetail={apartmentDetail} />,
    <StepTwoComponent
      key="2"
      initialValues={initialValues}
      next={handleNextStep}
      prev={handlePrevStep}
      apartmentDetail={apartmentDetail}
    />,
  ];

  return (
    <div id="paymentPage" className="container">
      <div className="payment-page">
        {/* Step */}
        <div className="row mx-0 no-printme">
          <Stepper>
            <Step pageIndex={currentStep + 1} indicator={1} title={t('payment.label_sumary')}></Step>
            <Step pageIndex={currentStep + 1} indicator={2} title={t('payment.label_paymentDetail')}></Step>
            <Step pageIndex={currentStep + 1} indicator={3} title={t('payment.label_confirmation')}></Step>
          </Stepper>
        </div>
        {steps[currentStep]}
      </div>
    </div>
  );
}

export default PaymentSummaryComponent;
